import React, { useEffect } from "react";
import "./Advantage3.css";
import num3dark from "../images/num3-dark.png";

const Advantage3 = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = document.querySelectorAll(".advantage3-1 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="advantage3-1">
      <div className="advantage3-2">
        <div className="img3-1 animate-side slide-left">
          <div
            className="logo-light"
            style={{
              backgroundImage: `url(${num3dark})`,
            }}
          />
        </div>
        <div className="advantage3-content animate-side slide-right">
          <h1>Enhanced Customer Experience & Engagement</h1>
          <div className="advantage3-3">
            <p>
              <label>Omnichannel Convenience:</label>
              Provide customers with a cohesive experience whether ordering in-person via digital menus, through an e-commerce storefront, or via a mobile app.<br/>
              <label>Faster Checkout & Service:</label>
              Optimized POS interfaces and instant table-side ordering reduce wait times and keep transaction flows smooth.<br/>
              <label>Tailored Customer Retention:</label>
              Integrated loyalty tracking and customer insights let you offer personalized rewards and targeted promotions automatically.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advantage3;